import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

export const useUpdateImages = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: DrugsApi.updateImages,
    onSuccess: async (_, { drug_id }) => {
      await queryClient.invalidateQueries(DrugsQueryKeys.getImagesKey({ drug_id }));
    },
  });
};
